import { userInfoFrag } from '../../../../utils/type/user.common-type';

export const getUsersFrag = `
    ${userInfoFrag}
    employments(input: __USER_INPUT__) {
        employmentTypeName
        employmentGroupName
    }
`;

export const getLastRegistrationNumberFrag = `
    id
    registrationNumber
`;
